(function () {
  "use strict";
  if (window.__frgCaseCleanup) return;
  window.__frgCaseCleanup = true;

  var busy = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function isCartPage() {
    return !!(
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.pageType === "cart"
    );
  }

  function hasCaseInDom() {
    return !!document.querySelector(
      ".line-item--bundled-case[data-frg-case-key]",
    );
  }

  // Only LOCKED cases (the free subscription case) follow the parent's
  // quantity. The paid travel-spray case is an optional add-on with its own
  // controls; it is still dropped below if its parent leaves the cart.
  function caseKeysForParent(parentVariantId) {
    var keys = [];
    var nodes = document.querySelectorAll(
      '.line-item--bundled-case[data-frg-case-locked][data-frg-parent-id="' +
        parentVariantId +
        '"]',
    );
    for (var i = 0; i < nodes.length; i++) {
      var key = nodes[i].getAttribute("data-frg-case-key");
      if (key) keys.push(key);
    }
    return keys;
  }

  function applyUpdates(updates) {
    if (busy || !updates) return;
    busy = true;

    var onCart = isCartPage();
    var sections = [];
    if (!onCart) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sections },
        }),
      );
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );

    fetch(root() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates, sections: sections.join(",") }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart update failed");
        return r.json();
      })
      .then(function (cart) {
        busy = false;
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true }),
        );
        if (onCart) {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: { baseEvent: "line-item:change", cart: cart },
          }),
        );
      })
      .catch(function () {
        busy = false;
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true }),
        );
        if (onCart) window.location.reload();
        else document.dispatchEvent(new CustomEvent("cart:refresh"));
      });
  }

  function syncParent(parentKey, targetQty) {
    if (parentKey == null || isNaN(targetQty)) return false;
    var parentVariantId = parentKey.split(":")[0];
    var caseKeys = caseKeysForParent(parentVariantId);
    if (!caseKeys.length) return false;

    var updates = {};
    updates[parentKey] = targetQty;
    for (var i = 0; i < caseKeys.length; i++) updates[caseKeys[i]] = targetQty;
    applyUpdates(updates);
    return true;
  }

  document.addEventListener(
    "click",
    function (e) {
      if (!hasCaseInDom()) return;
      var link =
        e.target.closest && e.target.closest('a[href*="/cart/change"]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.getAttribute("href"), window.location.origin);
      } catch (err) {
        return;
      }
      var key = url.searchParams.get("id");
      var qtyRaw = url.searchParams.get("quantity");
      if (!key || qtyRaw === null) return;
      if (!caseKeysForParent(key.split(":")[0]).length) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (busy) return;
      syncParent(key, parseInt(qtyRaw, 10));
    },
    true,
  );

  document.addEventListener(
    "change",
    function (e) {
      if (!hasCaseInDom()) return;
      var input = e.target;
      if (!input || !input.getAttribute) return;
      var key = input.getAttribute("data-line-key");
      if (!key || !caseKeysForParent(key.split(":")[0]).length) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (busy) return;
      syncParent(key, parseInt(input.value, 10));
    },
    true,
  );

  function orphanUpdates(cart) {
    var items = (cart && cart.items) || [];
    var parentVariants = {};
    var parentTitles = {};
    var i, it, p;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      p = it.properties || {};
      if (!p._case_for) {
        parentVariants[it.variant_id] = true;
        if (it.product_title) parentTitles[it.product_title] = true;
      }
    }
    var updates = null;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      p = it.properties || {};
      if (!p._case_for) continue;
      var hasParent =
        p._parent_id != null
          ? !!parentVariants[p._parent_id]
          : !!(p._linked_to && parentTitles[p._linked_to]);
      if (!hasParent) {
        updates = updates || {};
        updates[it.key] = 0;
      }
    }
    return updates;
  }

  document.addEventListener("cart:change", function (e) {
    if (busy) return;
    var cart = e.detail && e.detail.cart;
    if (cart) applyUpdates(orphanUpdates(cart));
  });

  function loadCheck() {
    if (!hasCaseInDom()) return;
    fetch(root() + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyUpdates(orphanUpdates(cart));
      })
      .catch(function () {});
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadCheck);
  } else {
    loadCheck();
  }
})();
